module.exports = __webpack_public_path__ + "static/media/arrowUpRed.d6b61a49.svg";